import equal from "deep-equal";
import {
  Habit,
  Instance,
  InstanceOverride,
  instanceOverrideEntitySchema,
} from "src/database/types";
import { pick } from "src/utils/pick";

/** Written to every override, even when identical to the habit template. */
const alwaysOverride = [
  "id",
  "type",
  "date",
  "templateId",
  "order",
  "completed",
] as const satisfies Array<keyof InstanceOverride>;

const overrideable = new Set(Object.keys(instanceOverrideEntitySchema.shape));

/**
 * Build the sparse override record for a single day's instance of a habit:
 * the always-present identity/state fields, plus any overrideable field whose
 * value has diverged from the habit template.
 */
export function buildInstanceOverride(item: Instance, habit: Habit): InstanceOverride {
  const newRecord: InstanceOverride = pick(item, alwaysOverride);
  const keys = Object.keys(item) as Array<keyof Instance>;
  for (const key of keys) {
    if (alwaysOverride.includes(key as (typeof alwaysOverride)[number])) {
      continue;
    }
    if (key in habit && overrideable.has(key) && !equal(item[key], habit[key as keyof Habit])) {
      newRecord[key as keyof InstanceOverride] = item[key as keyof InstanceOverride];
    }
  }
  return newRecord;
}
